/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MoneyOutput } from './MoneyOutput';
import {
    MoneyOutputFromJSON,
    MoneyOutputFromJSONTyped,
    MoneyOutputToJSON,
    MoneyOutputToJSONTyped,
} from './MoneyOutput';

/**
 * 
 * @export
 * @interface MoneyCalculationDataTransferObject
 */
export interface MoneyCalculationDataTransferObject {
    /**
     * 
     * @type {number}
     * @memberof MoneyCalculationDataTransferObject
     */
    percentageChangeAgainstPreviousPeriod?: number;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof MoneyCalculationDataTransferObject
     */
    value?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof MoneyCalculationDataTransferObject
     */
    valuePreviousPeriod?: MoneyOutput;
    /**
     * 
     * @type {{ [key: string]: MoneyOutput; }}
     * @memberof MoneyCalculationDataTransferObject
     */
    valueGranular?: { [key: string]: MoneyOutput; };
    /**
     * 
     * @type {{ [key: string]: MoneyOutput; }}
     * @memberof MoneyCalculationDataTransferObject
     */
    valueGranularPreviousPeriod?: { [key: string]: MoneyOutput; };
}

/**
 * Check if a given object implements the MoneyCalculationDataTransferObject interface.
 */
export function instanceOfMoneyCalculationDataTransferObject(value: object): value is MoneyCalculationDataTransferObject {
    return true;
}

export function MoneyCalculationDataTransferObjectFromJSON(json: any): MoneyCalculationDataTransferObject {
    return MoneyCalculationDataTransferObjectFromJSONTyped(json, false);
}

export function MoneyCalculationDataTransferObjectFromJSONTyped(json: any, ignoreDiscriminator: boolean): MoneyCalculationDataTransferObject {
    if (json == null) {
        return json;
    }
    return {
        
        'percentageChangeAgainstPreviousPeriod': json['percentageChangeAgainstPreviousPeriod'] == null ? undefined : json['percentageChangeAgainstPreviousPeriod'],
        'value': json['value'] == null ? undefined : MoneyOutputFromJSON(json['value']),
        'valuePreviousPeriod': json['valuePreviousPeriod'] == null ? undefined : MoneyOutputFromJSON(json['valuePreviousPeriod']),
        'valueGranular': json['valueGranular'] == null ? undefined : (mapValues(json['valueGranular'], MoneyOutputFromJSON)),
        'valueGranularPreviousPeriod': json['valueGranularPreviousPeriod'] == null ? undefined : (mapValues(json['valueGranularPreviousPeriod'], MoneyOutputFromJSON)),
    };
}

export function MoneyCalculationDataTransferObjectToJSON(json: any): MoneyCalculationDataTransferObject {
    return MoneyCalculationDataTransferObjectToJSONTyped(json, false);
}

export function MoneyCalculationDataTransferObjectToJSONTyped(value?: MoneyCalculationDataTransferObject | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'percentageChangeAgainstPreviousPeriod': value['percentageChangeAgainstPreviousPeriod'],
        'value': MoneyOutputToJSON(value['value']),
        'valuePreviousPeriod': MoneyOutputToJSON(value['valuePreviousPeriod']),
        'valueGranular': value['valueGranular'] == null ? undefined : (mapValues(value['valueGranular'], MoneyOutputToJSON)),
        'valueGranularPreviousPeriod': value['valueGranularPreviousPeriod'] == null ? undefined : (mapValues(value['valueGranularPreviousPeriod'], MoneyOutputToJSON)),
    };
}

